module.exports = __webpack_public_path__ + "img/installation-5.c7e71e81.png";